import { render } from "./yi-index.vue?vue&type=template&id=7f242ac6&scoped=true"
import script from "./yi-index.vue?vue&type=script&lang=js"
export * from "./yi-index.vue?vue&type=script&lang=js"

import "./yi-index.vue?vue&type=style&index=0&id=7f242ac6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f242ac6"]])

export default __exports__